const MAX_MESSAGE_LENGTH = 500;

const MESSAGES = {
    network: "Не удалось подключиться к серверу. Проверьте подключение к интернету.",
    validation: "Проверьте введенные данные.",
    unauthorized: "Требуется повторный вход в систему.",
    forbidden: "У вас нет доступа к этой операции.",
    not_found: "Запрошенный ресурс не найден.",
    conflict: "Операция не может быть выполнена из-за конфликта данных.",
    rate_limited: "Слишком много запросов. Повторите позже.",
    server: "Сервис временно недоступен. Повторите позже.",
};

const isObject = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

const safeText = (value) => typeof value === "string" ? value.slice(0, MAX_MESSAGE_LENGTH) : null;

const getFieldErrors = (value) => {
    if (!isObject(value)) return {};

    return Object.entries(value).reduce((fieldErrors, [field, messages]) => {
        if (!Array.isArray(messages)) return fieldErrors;

        const safeMessages = messages
            .map(safeText)
            .filter((message) => message !== null);
        if (safeMessages.length > 0) fieldErrors[field] = safeMessages;
        return fieldErrors;
    }, {});
};

const result = (kind, message, fieldErrors = {}) => ({kind, message, fieldErrors});

export const mapApiError = (error) => {
    const response = error?.response;
    if (!response) return result("network", MESSAGES.network);

    const status = response.status;
    const data = isObject(response.data) ? response.data : {};
    if (status === 400 || status === 422) {
        return result(
            "validation",
            safeText(data.message) || MESSAGES.validation,
            getFieldErrors(data.field_errors),
        );
    }

    if (status === 401) return result("unauthorized", MESSAGES.unauthorized);
    if (status === 403) return result("forbidden", MESSAGES.forbidden);
    if (status === 404) return result("not_found", MESSAGES.not_found);
    if (status === 409) return result("conflict", MESSAGES.conflict);
    if (status === 429) return result("rate_limited", MESSAGES.rate_limited);
    if (status >= 500) return result("server", MESSAGES.server);
    return result("server", MESSAGES.server);
};
